export const baseURL: string = "https://express-tire-api-e3fsagg7hnfgf9c8.canadacentral-01.azurewebsites.net/api/";
export const vehiclesDetailsAPIURL: string = "https://vpic.nhtsa.dot.gov/api/vehicles/";
